export default __webpack_public_path__ + "static/ascendoffice-b62c6d4264aff52c7ec50b2bbdbf4767.png";